import { TyrianApp } from './client/target/scala-3.7.4/the-yearning-client-opt/main.js';
import i18next from 'i18next';
import en from './src/locales/en.json';

(async () => {
  await i18next.init({ lng: 'en', resources: { en: { translation: en } } });
  TyrianApp.launch('myapp');
})();
